import React from 'react';
import SubPage from '../SubPage';
import FAQ from './faqData';
import useSite from '../../useSite';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: '고객 센터', en: 'Support' };
const T = {
  title: { ko: '자주 묻는 질문', en: 'FAQ' },
  lede:  { ko: '궁금한 점이 있으시면 아래를 확인해 주세요.', en: 'Find quick answers below.' },
};

function Faq() {
  const { lang } = useLang();
  const rows = useSite('/api/site/faq', null);
  const groups = rows
    ? rows.reduce((acc, r) => {
        const name = (lang === 'en' && r.CATEGORY_EN) ? r.CATEGORY_EN : r.CATEGORY;
        let g = acc.find((x) => x.name === name);
        if (!g) { g = { name, items: [] }; acc.push(g); }
        g.items.push({
          q: (lang === 'en' && r.QUESTION_EN) ? r.QUESTION_EN : r.QUESTION,
          a: (lang === 'en' && r.ANSWER_EN) ? r.ANSWER_EN : r.ANSWER,
        });
        return acc;
      }, [])
    : FAQ.map((g) => ({ name: g.title[lang], items: g.items.map((i) => ({ q: i.q[lang], a: i.a[lang] })) }));
  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      {groups.map((g, gi) => (
        <div key={gi}>
          <h3 className="sp-group-h">{g.name}</h3>
          <div className="sp-faq">
            {g.items.map((it, i) => (
              // 첫 그룹 첫 질문만 펼친 상태로 시작(시안과 동일)
              <details key={i} open={gi === 0 && i === 0}>
                <summary>{it.q}</summary>
                <div className="fa">{it.a}</div>
              </details>
            ))}
          </div>
        </div>
      ))}
    </SubPage>
  );
}

export default Faq;
